import React from "react";
import { RadioButton } from "@graffer-inc/console-design-kit";

type Props = {
  value?: boolean;
  onChange: (value: boolean) => void;
};

export const ProcedureTopPageSetting: React.FC<Props> = ({
  value = true,
  onChange,
}) => {
  return (
    <div className="field">
      <div className="control" style={{ marginTop: "10px" }}>
        <RadioButton
          label={"トップページ設定"}
          description={
            "トップページにリンクしない設定にすると、ヘッダー・申請完了画面からトップページに遷移するリンクが非表示になります。"
          }
          options={[
            {
              value: "NOT_LINK",
              name: "トップページにリンクしない",
            },
            {
              value: "LINK",
              name: "トップページにリンクする",
            },
          ]}
          required={false}
          value={value ? "LINK" : "NOT_LINK"}
          onChange={() => onChange(!value)}
          direction={"row"}
        />
      </div>
    </div>
  );
};
